module.exports = "<lottie-animation-view\n  [options]=\"lottieConfig\"\n  [width]=\"250\"\n></lottie-animation-view>\n"